import { useNavigate } from "react-router-dom";
import Button from "../common/Button";
import Image from "../common/Image";
import video from "../../assets/images/landing/Invest_Uttarakhand.mp4";

const Banner = ({
  image,
  title,
  description,
  buttonUrl = "",
  isParyatanYojana = false,
  language = false,
}) => {
  const navigate = useNavigate();
  return (
    <section className="banner-section">
      <div className="relative min-h-[450px] md:min-h-[500px] lg:min-h-[700px] w-full overflow-hidden flex items-center">
        {/* Background image */}
        {/* <Image
          src={image}
          alt="Mountain"
          className="absolute inset-0 w-full h-full object-cover z-0"
        /> */}
        <video
          className="absolute inset-0 w-full h-full object-cover z-0"
          src={video}
          autoPlay
          muted
          loop
          playsInline
        />

        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#018f9b]/90 to-green-600/10 z-10"></div>

        {/* Text */}
        <div className="relative z-20 w-full">
          <div className="container mx-auto px-4 md:px-8 text-white text-left">
            <div className="max-w-4xl py-12 md:py-20">
              <h2 className="text-2xl sm:text-3xl text-white  md:text-4xl lg:text-5xl font-bold leading-tight mb-4 wow fadeInDown">
                {language ? title.hi : title.en}
              </h2>
              <p className="text-sm sm:text-base md:text-lg leading-relaxed text-white">
                {language ? description.hi : description.en}
              </p>
              {buttonUrl && (
                <Button
                  className="mt-10 inline-flex items-center bg-[#FF9810] text-white px-6 py-3 rounded-full font-semibold hover:opacity-90 transition"
                  onClick={() => {
                    isParyatanYojana
                      ? navigate(buttonUrl)
                      : window.open(buttonUrl, "_blank", "noopener,noreferrer");
                  }}
                >
                  {language ? "अभी अप्लाई करें" : "Apply Now"} →
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Banner;
